import React from "react";
import ReactDOM from "react-dom";
import { PostHogProvider} from 'posthog-js/react';
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Router from "./context/Router";
import StatusProvider from "./context/Status";
import ErrorAlertProvider from "./context/ErrorAlert";
import BankTransferProvider from "./context/BankTransfer";
import UssdContextProvider from "./context/Ussd";

const options = {
    api_host: "https://app.posthog.com",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
}


ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <PostHogProvider
                apiKey={process.env.REACT_APP_POSTHOG_KEY as string}
                options={options}>
                <Router>
                    <ErrorAlertProvider>
                        <StatusProvider>
                            <BankTransferProvider>
                                <UssdContextProvider>
                                    <App />
                                </UssdContextProvider>
                            </BankTransferProvider>
                        </StatusProvider>
                    </ErrorAlertProvider>
                </Router>
            </PostHogProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();